import React from 'react';
import { GitBranch } from 'lucide-react';

type SplitChatIconProps = {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
  color?: string;
  strokeWidth?: number;
};

/**
 * SplitChatIcon — standardized split icon (top-down, tail on the right).
 * Wraps lucide-react's GitBranch and applies the canonical transform.
 */
const SplitChatIcon: React.FC<SplitChatIconProps> = ({
  size = 14,
  className,
  style,
  title,
  color,
  strokeWidth,
}) => {
  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 0,
        transform: 'rotate(180deg) scaleX(-1)',
        transformOrigin: 'center',
        ...style,
      }}
      aria-hidden={title ? undefined : true}
      aria-label={title}
    >
      <GitBranch size={size} color={color} strokeWidth={strokeWidth} />
    </span>
  );
};

export default SplitChatIcon;
